import React, { memo } from "react";
import { Link, navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const CategoryCard = ({ category, index }) => {
  return (
    <div
      key={index}
      className="relative block w-full pr-5 box-border rounded-[10px] flex-grow-0 flex-shrink-0 basis-[92%] md:basis-[46.7%] lg:basis-[24%]"
    >
      <div
        role="button"
        onClick={() =>
          navigate(
            `${category.buttonLink}?vendor=${encodeURIComponent(
              category.vendor
            )}`
          )
        }
        className="relative no-underline rounded-[10px] overflow-hidden box-border  w-full h-full
        cursor-pointer hover:shadow-['10px 10px 10px rgba(0, 0, 0, 0.1)']"
      >
        <div className="relative overflow-hidden border-inherit pb-[100%]">
          {category.image ? (
            <div className="absolute w-full h-full top-0 left-0 rounded-[10px] z-[-1] overflow-hidden">
              <GatsbyImage
                image={category.image.gatsbyImageData}
                alt={category.image.title || " "}
                className="relative w-full h-full rounded-[10px] z-[-1] object-cover"
                objectFit="cover"
                objectPosition="center"
                loading="lazy"
              />
            </div>
          ) : (
            <div
              className="absolute block top-0 left-0 max-w-full w-full h-full align-bottom object-cover object-center
              border-inherit bg-gray-900"
            />
          )}
        </div>
        <div
          className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center
          text-center p-5 md:p-10 bg-black/25 border-inherit group"
          role="group"
        >
          <h2
            className="text-xl md:text-3xl font-bold text-white leading-[30px] md:leading-[45px] tracking-[0.4px] transform
            translate-y-5 md:translate-y-[50px] group-hover:translate-y-0 transition-transform duration-[400ms] "
          >
            {category.title}
          </h2>
          <div
            className="flex flex-col items-center transform translate-y-5 md:translate-y-[50px] group-hover:translate-y-0
            transition-all duration-[400ms] opacity-0 group-hover:opacity-100"
          >
            <Link
              to={`${category.buttonLink}?vendor=${encodeURIComponent(
                category.vendor
              )}`}
              className="hidden md:block py-[6px] px-[15px] text-[15px] font-bold leading-7 tracking-[1px] no-underline
               text-[#1f1f1f] rounded-full bg-white"
            >
              {category.buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EmptyCard = ({ title, handle, category }) => {
  return (
    <div className="relative block w-full px-[10px] box-border flex-grow-0 flex-shrink-0 basis-[92%] md:basis-[46.7%] lg:basis-[24%]">
      <div className="relative block  border-inherit overflow-hidden rounded-[10px] no-underline cursor-pointer">
        <div className="relative block pb-[100%] overflow-hidden border-inherit">
          <div className="absolute block max-w-full w-full h-full top-0 left-0 align-bottom border-inherit bg-black/80 object-cover object-center" />
        </div>
        <div
          className="absolute top-0 left-0  w-full h-full flex flex-col justify-center items-center
         text-center p-5 md:p-[42px] bg-black/30 border-inherit overflow-clip"
        >
          <Link
            to={handle}
            state={{ category }}
            className="max-w-full w-fit no-underline px-[35px] md:px-[18px] py-3 text-[#1f1f1f] text-base font-bold leading-[27px]
            tracking-[1px] rounded-3xl bg-white"
          >
            {title}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default memo(CategoryCard);
